<template>
    <ion-page>
        <gridContainer :backBtn="isMobile" backText="Menu" :loading="!isLocationReady">
            <div v-if="fullMenu">
                <ion-row>
                    <ion-col>
                        <promoCard class="promo-header">
                            <template v-slot>
                                <contentBlock
                                    style="padding-top: 20px; padding-bottom: 20px"
                                    :backupText="`<h3 class='pb-8'>Decisions, Decisions…</h3> <h5>There's so much to love, you can't go wrong.</h5>`"
                                    :slug="'menu-category-' + category + '-10'"
                                />
                            </template>
                        </promoCard>
                    </ion-col>
                </ion-row>

                <ion-row v-if="!isMobile" class="category-links my-8 ion-padding-bottom ion-justify-content-center">
                    <template v-for="category in sortedMenuCategories" :key="category.name">
                        <ion-button
                            v-if="category.use_base_url"
                            @click="router.replace('/' + category.path)"
                            fill="clear"
                            size="small"
                            class="bold"
                            :color="'/' + category.path === $route.path ? 'dark' : 'primary'"
                        >
                            {{ category.name }}
                        </ion-button>
                        <ion-button
                            v-else
                            @click="router.replace('/menu/' + category.path)"
                            fill="clear"
                            size="small"
                            class="bold"
                            :color="'/menu/' + category.path === $route.path ? 'dark' : 'primary'"
                        >
                            {{ category.name }}
                        </ion-button>
                    </template>
                </ion-row>

                <ion-row v-if="topMenu?.length > 0" class="ion-justify-content-center mt-4 ion-margin-bottom" data-cy="classic-menu">
                    <ion-col v-for="(item, i) in topMenu" :key="i" :size="isMobile ? 12 : 3">
                        <menuItemCard :item="item" :category="category" :key="refresherKey" class="menu-item" detail />
                    </ion-col>
                </ion-row>

                <ion-row v-if="topMenu?.length > 0">
                    <ion-col>
                        <h2>
                            <b>{{ category == 'pizza' ? 'Signature Pizzas' : 'Entree & Party Sizes' }}</b>
                        </h2>
                    </ion-col>
                </ion-row>

                <ion-row v-if="bottomMenu" class="ion-justify-content-center" data-cy="regular-menu">
                    <ion-col v-for="(item, i) in bottomMenu" :key="i" :size="isMobile ? 12 : 3" class="my-4">
                        <menuItemCard :item="item" :category="category" :key="refresherKey" class="menu-item" detail :data-cy="'menu-item-' + item.path" />
                    </ion-col>
                </ion-row>
            </div>
            <div v-if="isMobile && cartCount > 0" class="spacer" style="margin-bottom: 60px"></div>
        </gridContainer>
        <ion-row v-if="isMobile && cartCount > 0" class="ion-no-margin force-bottom full-width">
            <ion-button color="primary" expand="full" class="ion-no-margin force-bottom full-width" style="font-size: 1.3em" @click="goToCart" size="large">Begin Checkout</ion-button>
        </ion-row>
    </ion-page>
</template>
<script lang="ts">
import { defineComponent, computed, ref, watch } from 'vue';
import { IonPage, IonRow, IonCol, IonButton, onIonViewWillEnter } from '@ionic/vue';
import { useStore } from 'vuex';
import updateMeta from '@/services/pageService';
import promoCard from '@/components/menu/promoCard.vue';
import contentBlock from '@/components/contentBlock.vue';
import menuItemCard from '@/components/menu/menuItemCard.vue';
import gridContainer from '@/components/layout/gridContainer.vue';
import useMenuRedirect from '@/composables/useMenuRedirect';
import { useRouter } from 'vue-router';
import { useUrlQueryParser } from '@/composables/useUrlQueryParser';
import { useMenuCategories } from '@/composables/useMenuCategories';
import { createSlug } from '@/services/stringService';

export default defineComponent({
    props: {
        category: String,
        backBtn: {
            type: Boolean,
            default: false,
        },
    },
    components: { IonPage, IonRow, IonCol, IonButton, promoCard, contentBlock, menuItemCard, gridContainer }, // backButton
    setup(props) {
        const router = useRouter();
        const store = useStore();
        const isMobile = computed(() => store.getters.isMobile);
        const cartCount = computed(() => store.getters.getCartQuantity);
        const { sortedMenuCategories } = useMenuCategories();
        const refresherKey = ref(0);
        const fullMenu = computed(() => store.getters.getLocationMenu?.find((c) => createSlug(c.name) === props.category));
        const topMenu = computed(() => fullMenu.value?.items.filter((i) => i.inTopMenu));
        const bottomMenu = computed(() => fullMenu.value?.items.filter((i) => !i.inTopMenu));
        const { handleQueries } = useUrlQueryParser();
        const { isLocationReady } = useMenuRedirect();

        const goToCart = () => {
            //@ts-ignore
            top.location.href = '/cart';
        };

        onIonViewWillEnter(() => {
            handleQueries();
        });

        watch(fullMenu, () => (refresherKey.value += 1));
        updateMeta({ title: fullMenu.value?.name });

        return { fullMenu, topMenu, bottomMenu, isMobile, sortedMenuCategories, isLocationReady, refresherKey, router, cartCount, goToCart };
    },
});
</script>

<style scoped>
.menu-item {
    height: 110px;
}
.category-links {
    font-size: 13px;
    white-space: nowrap;
    text-align: center;
}
</style>
